// extracted by mini-css-extract-plugin
export default {"searchClassName":"style_searchClassName__vKRAr","subTitle":"style_subTitle__fma3N","offSiteForm":"style_offSiteForm__13Hs5","confirmBtn":"style_confirmBtn__aW9tR"};